var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h-100"},[(!_vm.settings.tiny)?_c('ExportChartButton',{attrs:{"vega":_vm.vega}}):_vm._e(),_c('div',{ref:"vegaContainer",staticClass:"viz linechart h-100"}),(_vm.isLoading)?_c('div',{staticClass:"loading-container"},[_c('Spinner',{staticClass:"spinner"})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }